import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { CheckCircle2, Loader2 } from "lucide-react";
import { firePixel } from "../lib/pixel";
import { WHATSAPP_LINK } from "../i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadForm = ({ t }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error

  const submit = async (e) => {
    e.preventDefault();
    const cleanPhone = phone.replace(/\D/g, "");
    if (name.trim().length < 2 || cleanPhone.length < 10) {
      setStatus("error");
      return;
    }
    setStatus("loading");
    try {
      await axios.post(`${API}/leads`, {
        name: name.trim(),
        phone: cleanPhone,
        reward: "7% Welcome Bonus",
        source: "landing",
      });
      // Fire Meta Pixel conversion on successful registration
      firePixel("CompleteRegistration", { content_name: "cric1x_lead", value: 1, currency: "INR" });
      firePixel("Lead", { content_name: "cric1x_lead" });
      setStatus("success");
      localStorage.setItem("cric1x_lead_done", "1");
      setTimeout(() => {
        window.open(WHATSAPP_LINK, "_blank");
      }, 1400);
    } catch (err) {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex flex-col items-center justify-center gap-4 border border-gold/30 bg-black/40 p-10 text-center"
        data-testid="lead-success"
      >
        <CheckCircle2 className="text-wa" size={48} />
        <p className="font-display text-2xl font-semibold uppercase gold-text">Welcome to Cric1x</p>
        <p className="max-w-xs text-sm text-white/60">{t.form_success}</p>
      </motion.div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-7" data-testid="lead-form">
      <div>
        <label className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40">
          {t.form_name}
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Virat Sharma"
          className="mt-2 w-full border-b border-white/15 bg-transparent py-3 text-lg text-white placeholder:text-white/25 outline-none transition-colors focus:border-gold"
          data-testid="lead-name-input"
        />
      </div>
      <div>
        <label className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40">
          {t.form_phone}
        </label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="+91 98765 43210"
          className="mt-2 w-full border-b border-white/15 bg-transparent py-3 text-lg text-white placeholder:text-white/25 outline-none transition-colors focus:border-gold"
          data-testid="lead-phone-input"
        />
      </div>

      {status === "error" && (
        <p className="text-sm text-red-400" data-testid="lead-error">
          {t.form_error}
        </p>
      )}

      <button
        type="submit"
        disabled={status === "loading"}
        className="group flex w-full items-center justify-center gap-3 bg-gold py-4 font-display text-base font-bold uppercase tracking-widest text-black transition-transform hover:scale-[0.99] disabled:opacity-60"
        data-testid="lead-submit-btn"
      >
        {status === "loading" ? <Loader2 className="animate-spin" size={20} /> : t.form_submit}
      </button>
    </form>
  );
};
